import { useQuery } from '@tanstack/react-query'
import {
  fetchCommissionChildUsers,
  type CommissionChildUserQuery,
} from '@/api/map/commissionEligibility'

/**
 * Lab `commisionDashboard/getChildUser` — BQ player suggestions for chips.
 */
export function useCommissionChildUsers(
  query: CommissionChildUserQuery,
  enabled = true,
) {
  const player = query.player.trim()
  return useQuery({
    queryKey: [
      'commission-child-users',
      player,
      query.tripleMaster ?? '',
      query.doubleMaster ?? '',
      query.superMaster ?? '',
      query.master ?? '',
    ] as const,
    queryFn: () =>
      fetchCommissionChildUsers({
        player,
        tripleMaster: query.tripleMaster,
        doubleMaster: query.doubleMaster,
        superMaster: query.superMaster,
        master: query.master,
      }),
    enabled: enabled && player.length >= 1,
    staleTime: 10_000,
    retry: false,
  })
}
